const PilotQuality = [
  'TA',
  'JA',
  'VET',
  'REG',
  'Sprog',
];
export default PilotQuality;
